import React, {useRef, useState} from 'react';
import {useSelector} from 'react-redux';

import Carousel from '../../../../components/Carousel/Carousel';
import appConfig from '../../../../config/appConfig';
import * as dataConfig from '../../../../config/dataConfig/dataConfig';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import {selectIotDeviceType} from '../../../../state/selectors/iotDevice';
import {getFormattedDataIfNeeded} from './pauseModeDataService';
import PauseModeSlide from './PauseModeSlide';

const PauseModeCarousel = () => {
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const deviceType = useSelector(selectIotDeviceType);
    const pauseModeData = dataConfig.getPauseModeData(deviceType);
    const localizedStrings = getLocalizedStrings();
    const content = getFormattedDataIfNeeded(pauseModeData.content);
    const ref = useRef();
    const onVideoEnd = () => {
        const isAutoSlideEnabled = appConfig.getIsAutoSlideEnabled();

        if (!isAutoSlideEnabled) return;

        ref.current.next();
    };

    const onSlide = (index) => {
        setCurrentSlideIndex(parseInt(index));
    };

    return (
        <Carousel
            ref={ref}
            isControlArrowVisible
            ariaLabelLeft={localizedStrings[localizationKeys.DEVICE_SETTINGS_PAUSE_MODE_BTN_PREV_ARIA_LABEL]}
            ariaLabelRight={localizedStrings[localizationKeys.DEVICE_SETTINGS_PAUSE_MODE_BTN_NEXT_ARIA_LABEL]}
            controlArrowClassName='top-1/2 -translate-y-full md:block after:content-none before:border-primary'
            controlArrowLeftClassName='-left-14'
            controlArrowRightClassName='-right-14'
            onTransitionEnd={onSlide}
        >
            {content?.map((item, index) => (
                <PauseModeSlide
                    key={index}
                    slideData={item}
                    pauseModeData={pauseModeData}
                    isActiveSlide={index === currentSlideIndex}
                    onEnded={onVideoEnd}
                />
            ))}
        </Carousel>
    );
};

export default PauseModeCarousel;
